"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DescriptionMessages = _interopRequireDefault(require("../FormControlFragments/DescriptionMessages"));

var _InputLabel = _interopRequireDefault(require("../FormControlFragments/InputLabel"));

var _createUniqueElementIds = require("../../utils/createUniqueElementIds/createUniqueElementIds");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Checkbox = function Checkbox(_ref) {
  var checkboxRef = _ref.checkboxRef,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      errorMessages = _ref.errorMessages,
      formControlId = _ref.formControlId,
      handleOnChange = _ref.handleOnChange,
      handleOnKeyPress = _ref.handleOnKeyPress,
      inputId = _ref.inputId,
      isChecked = _ref.isChecked,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isGrouped = _ref.isGrouped,
      isRequired = _ref.isRequired,
      isValid = _ref.isValid,
      label = _ref.label,
      labelId = _ref.labelId,
      name = _ref.name,
      size = _ref.size,
      value = _ref.value;

  var _useState = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('label')),
      _useState2 = _slicedToArray(_useState, 1),
      labelUniqueId = _useState2[0];

  var _useState3 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('input')),
      _useState4 = _slicedToArray(_useState3, 1),
      inputUniqueId = _useState4[0];

  var _useState5 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('description')),
      _useState6 = _slicedToArray(_useState5, 1),
      descriptionUniqueId = _useState6[0];

  var checkboxStyles = (0, _classnames.default)('form-control__container form-control__container--checkbox', {
    'form-control__container--error': !isValid
  }, classes);
  var inputFieldStyles = (0, _classnames.default)('form-control__input--checkbox', {
    'form-control__input--error': !isValid,
    'form-control__input--checkbox-large': size === 'large'
  });

  var inputElement = /*#__PURE__*/_react.default.createElement("input", {
    id: inputId || inputUniqueId,
    name: name || inputId || inputUniqueId,
    value: value,
    type: "checkbox",
    onChange: handleOnChange,
    onKeyPress: handleOnKeyPress,
    required: isRequired,
    disabled: isDisabled,
    checked: isChecked,
    "aria-required": isRequired || null,
    "aria-invalid": !isValid || null,
    "aria-describedby": description && (descriptionId || descriptionUniqueId) || errorMessages && !isValid && (descriptionId || descriptionUniqueId) || null,
    className: inputFieldStyles,
    ref: checkboxRef,
    "data-testid": dataTestId
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: checkboxStyles,
    id: formControlId
  }, inputElement, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    isValid: isValid,
    label: label,
    labelId: labelId,
    labelUniqueId: labelUniqueId,
    inputId: inputId,
    inputUniqueId: inputUniqueId,
    type: "checkbox"
  }), (description || errorMessages && !isValid && !isGrouped) && /*#__PURE__*/_react.default.createElement(_DescriptionMessages.default, {
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    description: description,
    isDescriptionHtml: isDescriptionHtml,
    errorMessages: errorMessages,
    isDisabled: isDisabled,
    isValid: isValid
  }));
}; // needed for prop type checking refs in server side rendered apps


var Element = typeof Element === 'undefined' ? function () {} : Element; // eslint-disable-line

Checkbox.propTypes = {
  /**
   Optional. Ref passed to checkbox input.
   */
  checkboxRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]),

  /**
   Optional. Custom checkbox container styles.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Adds a distinct data-testid attribute used for testing suite hooks.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Custom description of input group. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. Custom ID for description of input group.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. Custom ID for checkbox container.
   */
  formControlId: _propTypes.default.string,

  /**
   Required. handleOnChange function.
   */
  handleOnChange: _propTypes.default.func.isRequired,

  /**
    Optional. handleOnKeyPress function.
    */
  handleOnKeyPress: _propTypes.default.func,

  /**
   Optional. Custom ID for \<input>.
   */
  inputId: _propTypes.default.string,

  /**
    Optional. Defaults false.
    */
  isChecked: _propTypes.default.bool,

  /**
   Optional. Used to pass HTML in the description prop. Defaults false.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
    Optional. Defaults false.
    */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Defaults false.
   */
  isGrouped: _propTypes.default.bool,

  /**
   Optional. Defaults false.
   */
  isRequired: _propTypes.default.bool,

  /**
    Optional. Defaults true.
    */
  isValid: _propTypes.default.bool,

  /**
   Required. Label.
   */
  label: _propTypes.default.string.isRequired,

  /**
    Optional. ID passed to the checkbox label element.
    */
  labelId: _propTypes.default.string,

  /**
    Optional. The name attribute for the input, which gets associated to the value.
    */
  name: _propTypes.default.string,

  /**
    Optional. Controls the size of the box and label. Options: 'large', 'small'. Defaults to 'large'.
    */
  size: _propTypes.default.oneOf(['large', 'small']),

  /**
   Optional. The unique value for the checkbox input which gets associated with the name attribute in the request. Defaults to true/false if not set.
   */
  value: _propTypes.default.string
};
Checkbox.defaultProps = {
  checkboxRef: null,
  classes: '',
  dataTestId: '',
  description: '',
  descriptionId: '',
  errorMessages: [],
  formControlId: '',
  handleOnKeyPress: function handleOnKeyPress() {},
  inputId: '',
  isChecked: false,
  isDescriptionHtml: false,
  isDisabled: false,
  isGrouped: false,
  isRequired: false,
  isValid: true,
  labelId: '',
  name: null,
  size: 'large',
  value: ''
};
var _default = Checkbox;
exports.default = _default;